import { styled } from "styled-components";

export const BookTitle = styled.span`
    font-family: Suburban;
    font-size: 4rem;
    line-height: 1.25;
    margin-bottom: 20ox;
    max-width: 50%;
    text-align: left;

    @media (max-width: 820px) {
        font-size: clamp(1.75rem, 1.5764rem + 2.7778vw, 3rem);
        max-width: 90%;
    }
`;

export const ContainerBook = styled.div`
    width: 70%;

    @media (max-width: 600px) {
        width: 100%;
    }

    @media (max-width: 370px) {
        .input-book {
            width: 250px!important;
        }
    }
   
    @media (max-width: 290px) {
        .input-book {
            width: 200px!important;
        }
    }
`;

export const BookDescription = styled.span`
    font-family: Roboto-Thin;
    line-height: 1.5;
    font-size: 1rem;
    margin-bottom: 20px;
    max-width: 50%;
    -webkit-user-select: none;
    text-align: left;

    @media (max-width: 820px) {
        font-size: clamp(0.7rem, 0.6583rem + 0.6667vw, 1rem);
        max-width: 90%;
    }
`;

export const FormContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    place-items: center;
    column-gap: 10px;
    width: 100%;

    @media (max-width: 850px) {
        grid-template-columns: 1fr;
        gap: 5px;
    }
`;

export const InformationContainer = styled.div`
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    margin-bottom: 100px;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;